///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportLocationsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected users: ReportUsersCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.users;
        }

        constructor(model: Dictionary<any>, properties: string[], {criteria}) {
            super(model, properties, criteria);

            this.users = new ReportUsersCollection(this.model[properties[0]], [], {
                criteria
            });

            this.title = 'LABEL_LOCATIONS';
            this.allSelectedLabel = 'LABEL_ALL_LOCATIONS';
            this.totalSelectedMessage = 'LABEL_TOTAL_LOCATIONS_SELECTED';
        }
    }
}
